import classNames from 'clsx'
import { bool, number, oneOf, string } from 'prop-types'

import {
  AVAILABLE_PRESCRIPTION_TYPES,
  PRESCRIPTION_TYPE_NO_PRESCRIPTION,
} from 'shared/consts/productTemplates'
import RedPointsBadge from 'views/components/atoms/RedPointsBadge'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { RED_POINTS_MODAL_ID } from 'views/consts'
import { getMultipliedRedPoints } from 'views/utils/redPointsUtils'

const ProductRedPointBadge = ({
  prescriptionType,
  className,
  redPoints,
  redPointsMultiplierIsValid,
  multiplierRP,
  badgeSize,
}) => {
  const wrapperClassName = classNames(
    className,
    'o-ProductTemplate__gallery--badge'
  )

  return (
    <div
      className={wrapperClassName}
      data-prescription-types={[PRESCRIPTION_TYPE_NO_PRESCRIPTION]}
      aria-hidden={
        ![PRESCRIPTION_TYPE_NO_PRESCRIPTION].includes(prescriptionType)
          ? true
          : null
      }
    >
      <ModalShowButton
        component={ButtonAsLink}
        modalId={RED_POINTS_MODAL_ID}
        name="RedPoints-modal"
        data-clientside-hook="imageGallery__redPoint"
      >
        <RedPointsBadge size={badgeSize}>
          +
          {getMultipliedRedPoints({
            redPoints,
            redPointsMultiplierIsValid,
            multiplierRP,
          })}
        </RedPointsBadge>
      </ModalShowButton>
    </div>
  )
}

ProductRedPointBadge.propTypes = {
  prescriptionType: oneOf(AVAILABLE_PRESCRIPTION_TYPES.ALL),
  className: string,
  redPoints: number,
  multiplierRP: number,
  redPointsMultiplierIsValid: bool,
  badgeSize: string,
}
ProductRedPointBadge.defaultProps = {
  prescriptionType: null,
  className: null,
  redPoints: null,
  multiplierRP: null,
  redPointsMultiplierIsValid: false,
  badgeSize: 'default',
}

export default ProductRedPointBadge
